import { useQuery } from "@tanstack/react-query";
import { fetchWorkingSetPlan } from "@api";
import PlanOfAction, { PlanSkeleton } from "@components/suggestions/PlanOfAction";

// Every account the user can see: the plan endpoint scopes an empty filter to their branches.
const ALL_ACCOUNTS = "";

const SuggestedForToday = () => {
  const planQuery = useQuery({
    queryKey: ["homePlan"],
    queryFn: ({ signal }) => fetchWorkingSetPlan({ query: ALL_ACCOUNTS }, { signal }),
    staleTime: 60_000,
    retry: false,
  });

  if (planQuery.isError) {
    return (
      <p className="rounded-xl border border-dashed border-zinc-200 px-4 py-3 text-xs text-zinc-500">
        Couldn't load today's suggestions.{" "}
        <button type="button" onClick={() => planQuery.refetch()} className="font-medium text-zinc-700 hover:underline">
          Try again
        </button>
      </p>
    );
  }
  if (!planQuery.data) return <PlanSkeleton />;
  return <PlanOfAction plan={planQuery.data} variant="home" />;
};

export default SuggestedForToday;
